/**
 * ——————————————————————————————
 * FUNCTION DEFINITIONS / GLOBALS
 * ——————————————————————————————
 */

// Toast notification
function showToast(content, location, duration = 2500) {
  const toast = document.createElement("div");
  toast.classList.add("toast");
  toast.textContent = content;

  toast.classList.add(`toast-${location}`);
  document.body.appendChild(toast);
  toast.addEventListener("click", () => (window.location = "/pages/wishlist"));
  setTimeout(() => {
    toast.classList.add("toast--active");
  }, 10);

  setTimeout(() => {
    toast.classList.remove("toast--active");
    toast.addEventListener(
      "transitionend",
      () => {
        toast.remove();
      },
      { once: true }
    );
  }, duration);
}

const isWishlistPage = window.location.pathname.replace("/pages/", "") === "wishlist";

const isProductPage = window.theme.template === "product";
const isCollection = window.theme.template === "collection";

const triggerWishlistRequest = (fn) => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(fn);
};

const addToWishList = (product) =>
  new Promise((resolve, reject) => {
    triggerWishlistRequest(() =>
      window._swat.addToWishList(
        product,
        (response) => {
          resolve(response);
        },
        (error) => {
          window.console.log({ error });
          reject(error);
        }
      )
    );
  });

const removeFromWishList = (product) =>
  new Promise((resolve, reject) => {
    triggerWishlistRequest(() =>
      window._swat.removeFromWishList(
        product,
        (response) => {
          resolve(response);
        },
        (error) => {
          window.console.log({ error });
          reject(error);
        }
      )
    );
  });

/**
 * We fetch all wishlist items and filter out setting only based checking if they have the cprops.stock_no property.
 */
const fetchItems = () =>
  new Promise((resolve) =>
    triggerWishlistRequest(() =>
      window._swat.fetch((items) => resolve(items.filter((wishlistItem) => !wishlistItem?.cprops?.stock_no)))
    )
  );

const hydrateWishlistTrigger = (triggerElement, selectedVariantId = null) => {
  if (!Boolean(selectedVariantId)) {
    triggerElement.dataset.wishlistProductVariant = "";
  }

  if (!selectedVariantId || !triggerElement) return;
  triggerElement.dataset.wishlistProductVariant = Number(selectedVariantId);
};

const hydrateLocalizedWishlist = async () => {
  const headerWishlistIcon = document.querySelector(".header--wishlist__icon");
  const wishlistItems = await fetchItems();
  window.wishlistItems = wishlistItems;
  window.wishlistItems.length > 0
    ? headerWishlistIcon.setAttribute("data-wishlisted", "true")
    : headerWishlistIcon.removeAttribute("data-wishlisted");

  const wishlistTriggers = [...document.querySelectorAll("[data-add-to-wishlist]")];

  if (isCollection) {
    // For collections, compare using the product id
    wishlistTriggers.forEach((trigger) => {
      const triggerVariant = Number(trigger.dataset.wishlistProductId);
      const foundItem = window.wishlistItems.find((item) => item.empi === triggerVariant);
      foundItem ? trigger.setAttribute("data-wishlisted", "true") : trigger.removeAttribute("data-wishlisted");
    });
  } else {
    // For product pages, compare using the variant id
    wishlistTriggers.forEach((trigger) => {
      const triggerVariant = Number(trigger.dataset.wishlistProductVariant);
      const foundItem = window.wishlistItems.find((item) => item.epi === triggerVariant);
      foundItem ? trigger.setAttribute("data-wishlisted", "true") : trigger.removeAttribute("data-wishlisted");
    });
  }

  updateWishlistCounter();

  return wishlistItems;
};

updateWishlistCounter = (count) => {
  const updateCount = (count, wishlistCount, wishlistCountInner) => {
    if (!wishlistCount || !wishlistCountInner) {
      return;
    }
    if (window.wishlistItems.length < 1 || count === 0) {
      wishlistCount.classList.remove("active");
      return;
    }
    if (count) {
      wishlistCountInner.innerText = String(count);
    } else {
      wishlistCountInner.innerText = String(window.wishlistItems.length);
    }
    wishlistCount.classList.add("active");
  };

  const wishlistCounts = document.querySelectorAll(".wishlist__count");
  const wishlistCountInners = document.querySelectorAll(".wishlist__count span");

  wishlistCounts.forEach((wishlistCount, index) => {
    const wishlistCountInner = wishlistCountInners[index];
    updateCount(count, wishlistCount, wishlistCountInner);
  });

  if (isWishlistPage) {
    const wishlistCountHeader = document.querySelector(".wishlist__count-header");
    const wishlistCountInnerHeader = document.querySelector(".wishlist__count-header span");
    updateCount(count, wishlistCountHeader, wishlistCountInnerHeader);
  }
};

const handleWishlistTriggerClick = async (trigger) => {
  const isWishlisted = Boolean(trigger.dataset.wishlisted);
  const isVariantSelected = Boolean(trigger.dataset.wishlistProductVariant);
  const wishlistWarningMessage = document.querySelector(".select-variant-message");

  if (wishlistWarningMessage) {
    if (isVariantSelected) {
      wishlistWarningMessage.classList.add("hidden");
    } else {
      wishlistWarningMessage.innerHTML = `<p>${wishlistWarningMessage?.dataset?.wishlistMessage}</p>`;
      wishlistWarningMessage?.classList.remove("hidden");
    }
  }

  if (!isVariantSelected) return;

  const item = {
    epi: Number(trigger.dataset.wishlistProductVariant),
    empi: Number(trigger.dataset.wishlistProductId),
    du: window.location.origin + trigger.dataset.wishlistProductUrl,
    pr: trigger.dataset.wishlistProductPrice,
  };

  if (isWishlisted) {
    const removeResponse = await removeFromWishList(item);
    if (removeResponse.ok === false) {
      throw new Error("Removing item from wishlist failed...");
    }
    trigger.removeAttribute("data-wishlisted");
    showToast("Removed from wishlist.", "bottom");
  } else {
    const addResponse = await addToWishList(item);
    if (addResponse.ok === false) {
      throw new Error("Adding item to wishlist failed...");
    }
    trigger.setAttribute("data-wishlisted", "true");
    showToast("Added to wishlist!", "bottom");
  }

  await hydrateLocalizedWishlist();

  updateWishlistCounter();
};

const removeAllVariantsFromWishList = async (productId) => {
  const wishlistItems = await fetchItems();
  const variants = wishlistItems.filter((item) => item.empi === productId);
  const removePromises = variants.map((variant) => removeFromWishList(variant));
  return await Promise.all(removePromises);
};

window.wishlistFunctions = window.wishlistFunctions || {};
window.wishlistFunctions.hydrateLocalizedWishlist = hydrateLocalizedWishlist;
window.wishlistFunctions.handleWishlistTriggerClick = handleWishlistTriggerClick;

/**
 * ——————————————————————————————
 * FUNCTION EXECUTION (DOM READY)
 * ——————————————————————————————
 */

window.addEventListener("DOMContentLoaded", async () => {
  const wishListCountNumberElements = document.querySelectorAll(".wishlist__count-number");
  triggerWishlistRequest(() => {
    window._swat.fetch((items) => {
      window.wishlistItems = items;
    });
  });

  await hydrateLocalizedWishlist();

  updateWishlistCounter();

  const rootUrl = window.theme.locale && window.theme.locale.primary ? "" : window.theme.locale.rootUrl;

  if (isProductPage) {
    const wishlistTrigger = document.querySelector("[data-add-to-wishlist]");
    const wishlistTriggers = [...document.querySelectorAll("[data-add-to-wishlist]")];
    const options = document.querySelector(".original-selector");
    const wishlistWarningMessage = document.querySelector(".select-variant-message");

    if (options) {
      options.addEventListener("change", () => {
        const selectedVariantId = Number(options.selectedOptions[0].value);
        const isWishlisted = window.wishlistItems.find((item) => item.epi === selectedVariantId);
        wishlistWarningMessage.classList.add("hidden");
        wishlistTriggers.forEach((trigger) => {
          hydrateWishlistTrigger(trigger, selectedVariantId);
          isWishlisted ? trigger.setAttribute("data-wishlisted", "true") : trigger.removeAttribute("data-wishlisted");
        });
      });
    }

    wishlistTriggers.forEach((trigger) => {
      trigger.addEventListener("click", async (evt) => {
        evt.preventDefault();
        await handleWishlistTriggerClick(trigger);
      });
    });
  } else if (isWishlistPage) {
    const gridWrapper = document.querySelector(".wishlist-container");

    gridWrapper.dataset.itemCount = Number(window.wishlistItems.length);

    const itemsLoopPromises = window.wishlistItems.map(async (item) => {
      const handle = item.du.split("products/")[1];
      const url = `${rootUrl}/products/${handle}?view=wishlist&variant=${item.epi}`;
      const response = await fetch(url);
      const itemsWrapper = gridWrapper.querySelector(".wishlist__items");

      if (response.ok === false) {
        throw new Error("Wishlist items response was not ok");
      }

      const data = await response.text();

      if (itemsWrapper) {
        itemsWrapper.insertAdjacentHTML("beforeend", data);
        const wishlistTriggers = [...document.querySelectorAll("[data-add-to-wishlist]")];
        wishlistTriggers.forEach((trigger) => trigger.setAttribute("data-wishlisted", "true"));
      }

      return data;
    });

    // Wait for all items to be fetched and inserted into the DOM
    await Promise.all(itemsLoopPromises);
    const $wishlistContainter = $(".wishlist-container");
    window.theme.applyAjaxToProductForm($wishlistContainter);

    const removeTriggers = gridWrapper.querySelectorAll(".wishlist__remove");
    theme?.ProductBlockManager?.loadImages();

    $(".show-12-more").click(function () {
      $(this).parent().toggleClass("result_hover");
    });

    // Handle Wishlist item removal
    gridWrapper.addEventListener("click", async (evt) => {
      const target = evt.target;

      if (!target?.attributes["data-remove-from-wishlist"] && !target?.attributes["data-add-to-wishlist"]) return;

      evt.preventDefault();

      const parent = target.closest("form");
      const id = Number(target?.dataset.wishlistProductVariant);
      const item = window.wishlistItems.find((item) => item.epi === id);
      const removeResponse = await removeFromWishList(item);
      const headerWishlistIcon = document.querySelector(".header--wishlist__icon");
      if (removeResponse.ok === false) {
        throw new Error("Removing item from wishlist failed...");
      }
      parent.remove();
      const updatedCount = Number(gridWrapper.dataset.itemCount) - 1;
      updateWishlistCounter(updatedCount);
      gridWrapper.dataset.itemCount = updatedCount;
      if (updatedCount === 0) {
        headerWishlistIcon.removeAttribute("data-wishlisted");
      }
    });

    document.addEventListener("wishlist-item-added-to-cart", (evt) => {
      const urlParams = new URLSearchParams(evt.detail.formData);
      const addedVariantId = Number(urlParams.get("id"));
      removeTriggers.forEach((trigger) => {
        const triggerVariantId = Number(trigger.dataset.wishlistProductVariant);
        if (Number(triggerVariantId) === addedVariantId) {
          trigger.click();
        }
      });
    });
  } else {
    // Assume trigger comes from a 'product-block' which is rendered to collection or homepage sections
    const wishlistTriggers = [...document.querySelectorAll("[data-add-to-wishlist]")];

    wishlistTriggers.forEach((trigger) => {
      const closestOptions = trigger.closest(".product-block").querySelector(".original-selector");
      const variantSelectorParent = closestOptions?.closest(".product-block__variant-select");
      const closeButton = variantSelectorParent?.querySelector("[data-plp-variant-selector-close]");

      closeButton?.addEventListener("click", () => {
        variantSelectorParent.classList.remove("is-shown");
      });

      if (closestOptions) {
        closestOptions.addEventListener("change", async () => {
          const selectedVariantId = Number(closestOptions.selectedOptions[0].value);
          hydrateWishlistTrigger(trigger, selectedVariantId);
          await handleWishlistTriggerClick(trigger);
          variantSelectorParent.classList.remove("is-shown");
        });

        // Handle additional UI for wishlist trigger
        trigger.addEventListener("click", async (evt) => {
          evt.preventDefault();
          const isWishlisted = Boolean(trigger.dataset.wishlisted);
          if (isWishlisted) {
            const removeResponse = await removeAllVariantsFromWishList(Number(trigger.dataset.wishlistProductId));
            if (removeResponse.ok === false) {
              throw new Error("Removing item from wishlist failed...");
            }
            trigger.removeAttribute("data-wishlisted");
            await hydrateLocalizedWishlist();
          } else {
            variantSelectorParent.classList.add("is-shown");
          }
        });
      } else {
        // default wishlist trigger
        trigger.addEventListener("click", async (evt) => {
          evt.preventDefault();
          await handleWishlistTriggerClick(trigger);
        });
      }
    });
  }

  // Remove items from the wish list page
  const removeWishListItemButtons = document.querySelectorAll(".wishlist-item-remove-btn");

  removeWishListItemButtons.forEach((removeWishListItemButton) => {
    removeWishListItemButton.addEventListener("click", async (evt) => {
      evt.preventDefault();
      const parent = removeWishListItemButton.closest(".wishlist__item");
      const id = Number(removeWishListItemButton?.dataset.wishlistProductVariant);
      const item = window.wishlistItems.find((item) => item.epi === id);
      const removeResponse = await removeFromWishList(item);
      if (removeResponse.ok === false) {
        throw new Error("Removing item from wishlist failed...");
      }
      parent.remove();
      const updatedCount = document.querySelectorAll(".wishlist__item").length;
      wishListCountNumberElements.forEach((wishlistCount) => {
        wishlistCount.innerHTML = updatedCount;
      });
    });
  });
});
